/*
  This button is less eye-catching than the primary button, but still very much useful for main actions.

  It’s monochromatic:
  • In light mode, it’s a high-contrast dark gray
  • In dark mode, it has a transparent background and a light gray outline

  Use it either for secondary actions, or for primary actions where I don’t want a super-bright eye-catching button.
*/

import { styled } from '@linaria/react';

import { DarkWrapper } from '@/components/ColorModeContainer';
import ButtonPlayful from './ButtonPlayful';

const ButtonSecondary = styled(ButtonPlayful)`
  --pb-background-color: var(--color-gray-900);
  --pb-highlight-color: var(--color-gray-800);

  ${DarkWrapper} & {
    --pb-background-color: transparent;
    --pb-highlight-color: hsl(210deg 15% 80% / 0.2);

    --selection-background-color: var(--pb-highlight-color);
    --selection-text-color: white;

    outline: 1px solid var(--color-gray-300);
    color: white;

    &:focus-visible {
      outline: 3px auto var(--color-primary);
    }
  }
`;

export default ButtonSecondary;
